import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const WorkShopandWebinar = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "Workshops & Webinars";

  const title = "Workshops & Webinars";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.1, // Delay each letter animation
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <style
        dangerouslySetInnerHTML={{
          __html: `
      @media screen and (max-width: 425px) {
        .page_title {
          font-size: 34px;
          line-height: 56px;
        }
      }
    `,
        }}
      />

      <Helmet>
        {/* Basic Meta Tags */}
        <title> Workshops and Webinars | MSB Association</title>
        <meta
          name="description"
          content="Discover MSB Association’s workshops and webinars offering actionable insights on industry challenges, fraud prevention, and compliance solutions."
        />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Workshops and Webinars | MSB Association "
        />
        <meta
          property="og:description"
          content="Discover MSB Association’s workshops and webinars offering actionable insights on industry challenges, fraud prevention, and compliance solutions."
        />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{
                display: "flex",
                flexDirection: "column", // stack lines vertically
                alignItems: "center",
                textAlign: "center",
                flexWrap: "wrap",
              }}
            >
              {title
                .replace(/\/n/g, "\n") // Convert "/n" to actual line breaks
                .split("\n")
                .map((line, lineIndex) => (
                  <div
                    key={`line-${lineIndex}`}
                    style={{
                      display: "flex",
                      flexWrap: "wrap", // ensure words wrap on smaller screens
                      justifyContent: "center",
                    }}
                  >
                    {line.split("").map((letter, charIndex) => {
                      const uniqueIndex = lineIndex * 30 + charIndex;
                      return (
                        <motion.span
                          key={`char-${lineIndex}-${charIndex}`}
                          custom={uniqueIndex}
                          initial="hidden"
                          animate="visible"
                          variants={letterVariants}
                          style={{
                            display: "inline-block",
                            marginRight: letter === " " ? "0.3rem" : "0",
                            whiteSpace: "pre",
                          }}
                        >
                          {letter}
                        </motion.span>
                      );
                    })}
                  </div>
                ))}
            </motion.h1>

            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="active">
                <a href="#!">Workshops & Webinars</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content">
              <h2 className="item_details_heading">
                {headingText.split("").map((char, i) => (
                  <motion.span
                    key={`${char}-${i}`}
                    custom={i}
                    initial="hidden"
                    animate="visible"
                    variants={headingVariants}
                  >
                    {char}
                  </motion.span>
                ))}
              </h2>
              <p>
                Thank you for visiting the page! We are currently preparing
                exciting training programs for you to upgrade your skills.
              </p>

              <h5>Stay Tuned for:</h5>
              <ul className="mt-4">
                <li>
                  <p>Interactive Sessions</p>
                </li>
                <li>
                  <p>Diverse Topics</p>
                </li>
                <li>
                  <p>Knowing it from the Best in Business</p>
                </li>
                <li>
                  <p>Networking opportunities</p>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default WorkShopandWebinar;
